import axios from '../../axios';

export default async function getSession() {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/session`,
    { skipAutoCancel: true }
  );
  if(response.status === 200) {
    return response.data
  }
  return null;
}